module.exports = __webpack_public_path__ + "static/img/phone.46ea48d.png";


//////////////////
// WEBPACK FOOTER
// ./static/phone.png
// module id = QA4G
// module chunks = 1